import classNames from "classnames";
import { FC } from "react";
import React from "react";

import { Button, IButtonProps } from "@/components/Button";

import { IWithRouteNavigatorWrapped, withRouteNavigator } from "./withRouteNavigator";

import "./_route-button.scss";

export interface IRouteButtonProps extends IWithRouteNavigatorWrapped, Omit<IButtonProps, "onClick"> {
  target?: "_blank" | "_self";
}

const RouteButtonComponent: FC<IRouteButtonProps> = ({
  onClick,
  href,
  className,
  target = "_self",
  ...buttonProps
}) => {
  const baseClass = "route-button";
  const rootClass = classNames(baseClass, className, {
    [`${baseClass}--block`]: buttonProps.display === "block",
  });

  return (
    <a
      href={href}
      onClick={onClick}
      target={target}
      className={rootClass}
      tabIndex={-1}
      {...(target === "_blank" && { rel: "noopener noreferrer" })}>
      <Button {...buttonProps} />
    </a>
  );
};

/**
 * @deprecated Use iris-based implementation instead.
 */
export const RouteButton = withRouteNavigator<IRouteButtonProps>(RouteButtonComponent);
